"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    userList (params) {
        return RequestbaseURL.get("itsm/v2/organization/user/list", params)
    }
}